import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';

import ProductsListBox from '../../components/inventorymng/ProductsListBox';
import ProductsList from '../../components/inventorymng/ProductsList';
import { listInventoryStocks, unloadInventoryStocks } from '../../modules/inventoryModule/invStocks';


const WarehouseInventoryListContainer = () => {

  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState("productNm");
  const [searchWords, setSearchWords] = useState(null);

  const { stocks, loading } = useSelector(
    ({ inventoryModule, loading }) => ({
      stocks: inventoryModule.invStocks.stocks,
      loading: loading['inventory/LIST_INV_STOCKS'],
    }),
  );

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listInventoryStocks());
    return () => unloadInventoryStocks();
  }, []);


  const searchList = (values) => {
    let searchData = {
      [searchKeyword]: values.searchWords,
    };
    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);

    dispatch(listInventoryStocks(searchData));
  }

  // 검색 카드 "초기화" - 별도 reset 액션이 없고 로컬 state라, 초기값으로 직접
  // 되돌리고 다시 조회한다(2026-10-22, taxIssuedmng과 동일한 패턴).
  const handleReset = () => {
    setSearchKeyword('productNm');
    setSearchWords('');
    dispatch(listInventoryStocks({}));
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable()
  });

  const formik = useFormik({
    initialValues: { searchKeyword: searchKeyword, searchWords: searchWords },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'whUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'stockUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        hide: true,
        type: 'string',
        editable: false,
      },

      {
        field: 'masPartnerNm',
        headerName: '제조사',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'pricePartnerNm',
        headerName: '매입처',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'category',
        headerName: '분류',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'modelNm',
        headerName: '모델명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productCnt',
        headerName: '수량',
        minWidth: 100,
        flex: 0.5,
        description: '',
        align: 'center',
        headerAlign: 'right',
        editable: false,
        valueFormatter: (value) => {
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `${valueFormatted}`;
        },
      },
      {
        field: 'priceVal',
        headerName: '가격',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        valueFormatter: (value) => {
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
    ],
    [],
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      <ProductsListBox formik={formik} onReset={handleReset} />
      <ProductsList
        columns={columns}
        rows={stocks}
        loading={loading}

        columnVisibilityModel={{
          id: false,
          whUuid: false,
          stockUuid: false,
          productUuid: false,
        }}
      />
    </Box>
  )
}

export default WarehouseInventoryListContainer